// extracted by mini-css-extract-plugin
export default {"title":"tabs-module--title--92db7","header":"tabs-module--header--1878a","tabs":"tabs-module--tabs--9dcef"};